.cardImage__clickable {
  cursor: pointer;
  outline: none;
}

.cardImage__clickable:focus-visible {
  filter: grayscale(0.5) opacity(0.7);
  transition: 250ms all;
}
